import React from "react";
import "./../../styles/components/Solutions.css";
import CurrentTheme from "./../CurrentTheme";
import config from "../../config";

export default function SolutionsIT() {
  return (
    <div className="solutions">
      <div className="bens-container">
        <div className="solutions-top">
          <div className="box-col">
            <div className="media-group">
              <a
                className="media-item"
                href="https://bens-digital-change.com/employeur#etape1"
                target="_blank"
                rel="noopener noreferrer"
              >
                <h4>
                  1. Registra il tuo datore di lavoro nella tua area clienti
                </h4>
                <img
                  src="/img/sol-01_emp.png"
                  alt="Sol 01"
                  loading="lazy"
                  width={340}
                  height={341}
                />
              </a>

              <a
                className="media-item"
                href="https://bens-digital-change.com/employeur#etape2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <h4>
                  2. Convalida del datore di lavoro da parte del nostro team
                </h4>
                <img
                  src="/img/sol-01_emp.png"
                  alt="Sol 02"
                  loading="lazy"
                  width={340}
                  height={351}
                />
              </a>
            </div>

            <div className="media-group">
              <a
                className="media-item"
                href="https://bens-digital-change.com/employeur#etape3"
                target="_blank"
                rel="noopener noreferrer"
              >
                <h4>
                  3. Scarica il documento da consegnare al tuo datore di lavoro{" "}
                </h4>
                <img
                  src="/img/sol-01_emp.png"
                  alt="Sol 03"
                  loading="lazy"
                  width={358}
                  height={351}
                />
              </a>

              <a
                className="media-item"
                href="https://bens-digital-change.com/employeur#etape4"
                target="_blank"
                rel="noopener noreferrer"
              >
                <h4>
                  4. Ricezione dei tuoi fondi (in EUR) entro 24 ore (giorni
                  lavorativi){" "}
                </h4>
                <img
                  src="/img/sol-01_emp.png"
                  alt="Sol 04"
                  loading="lazy"
                  width={351}
                  height={363}
                />
              </a>
            </div>
          </div>
          <div className="box-col solutions-top-right">
            <h2>
              <b>Nuovo servizio</b>
            </h2>
            <h2>
              Inizia a ricevere il tuo stipendio direttamente dal tuo datore di
              lavoro
            </h2>
            <p className="box-long-desc">
              Con il nostro servizio di scambio online, lo sei ora possibile
              ricevere il tuo stipendio sul tuo conto in euro in modo semplice,
              veloce e sicuro, senza dover aprire un conto bancario in Svizzera.
              Questo è ciò che <b>risparmia sulle spese</b> relative alla
              manutenzione dell'account, che può risultare piuttosto costoso.
            </p>
            <a
              href="https://bens-digital-change.swiss/register"
              target="_blank"
              rel="noopener noreferrer"
            >
              Iscrizione gratuita e non vincolante
            </a>
            <a
              href="https://calendly.com/bens_digital/demande-d-assistance"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contatta i nostri consulenti
            </a>
          </div>
        </div>

        <div className="section-08-box solutions-bottom">
          <div className="box-col">
            <img
              src="https://bens-digital-change.com/images/v2/get-mobile-back.webp"
              alt="Get Mobile"
              className="box-img"
              loading="lazy"
              width={733}
              height={671}
            />
          </div>
          <div className="box-col">
            <h2 className="box-title">
              La nostra soluzione è disponibile sul cellulare
            </h2>
            <img
              src="/img/bens-title-dark.svg"
              alt="Bens"
              className="box-desc-img"
              loading="lazy"
              width={399}
              height={51}
            />
            <p className="box-long-desc">
              Effettua tutte le tue transazioni in valuta estera sulla nostra
              applicazione disponibile su Android e IOS. Vuoi cambiare la tua
              valuta in un momento specifico?
            </p>
            <p className="box-long-desc">
              La nostra applicazione ti offre la possibilità di creare un avviso
              per avvisarti quando il tasso di cambio raggiunge quello da te Che
              volete.
            </p>
            <a
              href="https://bens-digital-change.ch/download-mobile-app"
              className="box-store"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://bens-digital-change.com/images/v2/bens-stores.webp"
                alt="Bens Store"
                loading="lazy"
              />
            </a>
          </div>
        </div>
      </div>
      <div
        className="solutions-back"
        style={{
          background:
            "linear-gradient(180deg, " +
            CurrentTheme(config.theme)["color"][0] +
            " 0%, " +
            CurrentTheme(config.theme)["color"][1] +
            " 100%)",
        }}
      ></div>
    </div>
  );
}
